module.exports = __webpack_public_path__ + "assets/img/star_sentence_select6.eb5ff4ed.png";